const { debounce } = require('lodash');

module.exports = (func, delayMilliseconds) => {
  const d = debounce(func, delayMilliseconds);

  return (e) => {
    e.persist();
    return d(e);
  };
};



// WEBPACK FOOTER //
// ./javascripts/components/shared/debounce.js